import { forwardRef } from 'react'

const Input = forwardRef(({
  label,
  error,
  helperText,
  className = '',
  type = 'text',
  ...props
}, ref) => {
  const inputId = props.id || props.name

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-pp-charcoal mb-2"
        >
          {label}
        </label>
      )}

      <input
        ref={ref}
        id={inputId}
        type={type}
        className={`
          w-full px-4 py-3 rounded-xl border bg-white text-pp-ink
          placeholder:text-pp-stone
          transition-colors duration-300
          focus:outline-none focus:ring-1
          ${error
            ? 'border-pp-terracotta focus:border-pp-terracotta focus:ring-pp-terracotta'
            : 'border-pp-dune focus:border-pp-sage focus:ring-pp-sage'
          }
          ${className}
        `}
        {...props}
      />

      {(error || helperText) && (
        <p className={`mt-2 text-sm ${error ? 'text-pp-terracotta' : 'text-pp-stone'}`}>
          {error || helperText}
        </p>
      )}
    </div>
  )
})

Input.displayName = 'Input'

export default Input
